import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { TrackingWidgetComponent } from './tracking-widget/tracking-widget.component';
import { QuotingWidgetComponent } from './quoting-widget/quoting-widget.component';

@NgModule({
	imports: [
		FormsModule,
		CommonModule
	],
	declarations: [
		TrackingWidgetComponent,
		QuotingWidgetComponent
	],
	exports: [
		TrackingWidgetComponent,
		QuotingWidgetComponent
	]
})
export class WidgetsModule { }